// extracted by mini-css-extract-plugin
export default {"section":"AssignedEquipmentSection_section__Jb56J","countText":"AssignedEquipmentSection_countText__pYad3","addButton":"AssignedEquipmentSection_addButton__S6E6D"};